import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClaimDetailComponent } from './claim-detail.component';
import { KButtonModule } from 'ng-k-button';
import { KTabsModule } from 'ng-k-tabs';
import { KIconModule } from 'ng-k-icon';
import { KCardModule } from 'ng-k-card';
import { KModalModule } from 'ng-k-modal';
import { KNotificationsModule } from 'ng-k-notifications';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentsComponent } from '../../nihl/documents/documents.component';
import { ClaimMedicalComponent } from '../claim-medical/claim-medical.component';
import { ClaimOutcomeComponent } from '../../common/claim-outcome/claim-outcome.component';
import { ImmunohistologicalMesotheliomaProfileComponent } from '../../mesothelioma/immunohistological-mesothelioma-profile/immunohistological-mesothelioma-profile.component';
 import { ImmunohistologicalCarcinomaProfileComponent } from '../../carcinoma-of-the-lung/immunohistological-carcinoma-profile/immunohistological-carcinoma-profile.component';
import { CustomBreadcrumbModule } from '../custom-breadcrumb/custom-breadcrumb.module';

@NgModule({
  declarations: [
    ClaimDetailComponent,
    DocumentsComponent,
    ClaimOutcomeComponent,
    ImmunohistologicalMesotheliomaProfileComponent,
    ImmunohistologicalCarcinomaProfileComponent,
    ClaimMedicalComponent
    ],
  imports: [
    CommonModule,
    KButtonModule,
    KTabsModule,
    KIconModule,
    KCardModule,
    KModalModule,
    KNotificationsModule,
    FormsModule,
    ReactiveFormsModule,
    CustomBreadcrumbModule
  ]
})
export class ClaimDetailModule { }
